import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CaptainChecklistComponent } from './captain-checklist.component';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'captain-checklist/:charterId',
        component: CaptainChecklistComponent,
      },
    ]),
  ],
  exports: [RouterModule],
})
export class CaptainChecklistRoutingModule {}
